module.exports = __webpack_public_path__ + "static/img/team-pic2.a445a087.png";